export const roleSelected = () => {
	return document.querySelectorAll('.clicked-node')
}